export function getCookie(cookieName) {
  const cookie = document.cookie.split(';').find((cookie) => cookie.trim().startsWith(`${cookieName}=`))
  if (cookie) {
    return cookie.split('=')[1]
  }
}

export function setCookie(cookieName, val, expires) {
  document.cookie = `${cookieName}=${val}; expires=${expires}; SameSite=Strict; Secure; path=/`;
}